import { graphql } from 'gatsby'
import React, { useCallback, useEffect, useState } from 'react'
import { Heading } from '../../../../components/Heading/Heading.styled'
import MessageBackground from '../../../../components/MessageBackground'
import SEO from '../../../../components/seo'
import Spacer from '../../../../components/Spacer'
import Wrapper from '../../../../components/Wrapper/Wrapper'
import { fetchMessages, fillSanityContent } from '../../data'
import { Category, MessageWithContent, Tab, TeamMessage } from '../../types'
import { parseTeamMessageContent } from '../../utils'
import { MessageCard } from '../components/message-card'
import {
  ButtonInsideContainer,
  ButtonText,
  TabButton,
  TabContainerNew,
  TabSlider,
} from '../components/tabs'

export default function Messages() {
  const [currentTab, setCurrentTab] = useState<Tab>(Tab.All)
  const [category, setCategory] = useState<Category>()
  const [loading, setLoading] = useState<boolean>(true)
  const [messages, setMessages] = useState<
    (MessageWithContent | TeamMessage)[]
  >([])

  const handleChangeTab = useCallback((tab: Tab): void => {
    if (tab === Tab.Team) {
      setCategory(Category.Team)
    } else {
      setCategory(undefined)
    }

    setCurrentTab(tab)
  }, [])

  const fetchData = useCallback(async (): Promise<void> => {
    setLoading(true)

    try {
      const messages = await fetchMessages({ category })
      if (category === Category.Team) {
        const messagesWithContent = parseTeamMessageContent(messages)
        setMessages(messagesWithContent)
      } else {
        const messagesWithContent = await fillSanityContent(messages)
        setMessages(messagesWithContent)
      }
    } catch (error) {
      console.error(error)
    }

    setLoading(false)
  }, [category])

  useEffect(() => {
    void fetchData()
  }, [fetchData])

  return (
    <>
      <SEO title='Messages' />
      <MessageBackground />
      <Wrapper noMobileMargins width='610px'>
        <Heading marginBottom='20px' style={{ color: 'black' }}>
          Messages
        </Heading>
        <Spacer space='50px' />
        <TabContainerNew>
          {Object.keys(Tab).map((tab, index, array) => {
            const isActive = currentTab === Tab[tab]
            const onClick = () => handleChangeTab(Tab[tab])
            return (
              <TabButton key={tab} aria-selected={isActive} onClick={onClick}>
                <ButtonInsideContainer>
                  <ButtonText isActive={isActive}>{tab}</ButtonText>
                </ButtonInsideContainer>
                <TabSlider isActive={isActive} index={index} array={array} />
              </TabButton>
            )
          })}
        </TabContainerNew>
        <Spacer space='50px' />
        {loading ? (
          <p>Loading...</p>
        ) : messages.length === 0 ? (
          <p>No messages found.</p>
        ) : (
          <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
            {messages.map((message) => (
              <li key={message.messageId}>
                <MessageCard message={message} />
              </li>
            ))}
          </ul>
        )}
      </Wrapper>
    </>
  )
}

export const query = graphql`
  query Messages($language: String) {
    locales: allLocale(filter: { language: { eq: $language } }) {
      ...FLocales
    }
  }
`
